<template>
  <div class="sidebar">
    <div class="sidebar-title">
      <img src="../../assets/image/logo-2.png" alt="" style="width:30px;height:30px;margin-top:10px;margin-left:5px">
      <div style="margin-left:5px" class="title"><span style="font-size:20px;font-weight: 700">深蓝&nbsp;</span><span
        style="font-size:14px;font-weight: 600;">新一代医院信息服务平台</span></div>
    </div>
    <div class="sidebar-box">
      <el-menu
        class="el-menu-vertical-demo"
        :collapse="false"
        :default-active="activeMenu"
        background-color="transparent"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical">
        <SidebarItem
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"></SidebarItem>
      </el-menu>
    </div>
  </div>
</template>

<script>

  import SidebarItem from "./SidebarItem";
  import {mapActions,mapGetters} from "vuex";
  import {fn} from "../../store/modules/conglomerate"
  import store from '../../store/index'


  export default {
    data () {
      return {
        permission_routes: []
      }
    },
    components: {SidebarItem},
    computed: {
      activeMenu :function () {

        const route = this.$route;

        var {meta, name} = route;//原来name是path
        if (name && name.indexOf('?') >= 0) {
          name = window.location.href;
          let arr = name.split('#');
          if (arr.length > 1) {
            name = decodeURI(arr[1]);

          }
        }
        // 默认激活项
        if (meta.activeMenu) {
          return meta.activeMenu;
        }
        // console.log('默认激活',route);
        return name;
      },
      variables:function () {
        return {
          menuText: "#ffffff",  // "#bfcbd9"
          menuActiveText: "#ffffff",
          menuBg: "#001529"
        };
      },
    },
    mounted(){
      this.permission_routes = store.getters.permission_routes
      // console.log(this.permission_routes)
      // this.menuList();
    },
    methods: {
      ...mapActions({
        post: "axios/post",
      }),
      // //获取树形菜单
      async menuList(){
        var menu = JSON.parse(localStorage.getItem('menu'));
        this.permission_routes = await fn(menu,"menu");
      }
    }
  };
</script>

<style scoped>
  .sidebar {
    width: 100%;
    height: 100%;
  }

  .sidebar-title {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #dcdfe6;
    color: #ffffff;
    box-sizing: border-box;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

  }

  .sidebar-box {
    width: 100%;
    height: calc(100% - 64px);
    overflow-x: hidden;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: "-moz-scrollbars-none";
    scrollbar-width: none; /*  火狐   */
  }

  .sidebar-box::-webkit-scrollbar {
    display: none; /*  Chrome  */
    width: 0 !important; /*  Chrome  */
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }

  .title {
    font-family: "Hiragino Sans GB";
  }
</style>
